import { useApi } from "@/lib/pariette";
import { startApprovalPolling, type ApprovalData } from "@/lib/approval-polling";
import { useToast } from "./use-toast";

/**
 * 2FA onay akışı hook'u.
 *
 * Dosya adı ve `useSocket` export'u geriye dönük uyumluluk için korundu
 * (30'a yakın çağrı yeri var), ancak ARTIK SOCKET KULLANMIYOR —
 * socket.demapi.de emekliye ayrıldı. İçerideki mekanizma
 * `GET auth/approval-status/{poll_token}` yoklamasına çevrildi.
 * Bkz. @/lib/approval-polling.
 */
export const useSocket = () => {
  const { $post, $put } = useApi();
  // noAlert: yoklama sırasında 403/410 normal akışın parçası, toast basılmamalı.
  const { $get } = useApi(true);
  const { toast } = useToast();

  const checkRules = async (data: { operation: string }, info: any, updateData: object, after: (res: any) => void, socketData?: any) => {
    const newData = {
      ...data,
      info: info,
    };

    if (socketData) {
      waitForApproval(socketData, updateData, after, data);
    } else {
      await $post("confirmation-code", newData)
        .then((res) => {
          if (res.status) {
            waitForApproval(res.data, updateData, after, data);
          } else {
            if (res.httpStatus === 455) {
              updateWithCheckRules({ status: true }, updateData, after, data);
            } else {
              toast({ variant: "destructive", description: res.message });
            }
          }
        })
        .catch((err) => {
          if (err.code === 455) {
            updateWithCheckRules({ status: true }, updateData, after, data);
          }
        });
    }
  };

  /**
   * Eski `socket()` fonksiyonunun yerini alır. Backend artık socket_url/room
   * yerine poll_token dönüyor.
   */
  function waitForApproval(approvalData: ApprovalData | null, updateData: object, after: (res: any) => void, data: { operation: string }) {
    if (!approvalData?.poll_token) {
      return;
    }

    startApprovalPolling($get, approvalData, (outcome) => {
      updateWithCheckRules(outcome, updateData, after, data);
    });
  }

  const updateWithCheckRules = async (result: any, updateData: any, after: (res: any) => void, data: { operation: string }) => {
    if (!result.status) {
      toast({ variant: "destructive", description: "Aktualisierungsfehler" });
      after(result);
    } else {
      if (data.operation === "create") {
        await $post(updateData.api, updateData.data, {
          ConfirmationCode: result.code,
        })
          .then((response) => {
            after(response);
          })
          .catch((err) => {
            after(err);
          });
      } else {
        await $put(updateData.api, updateData.data, {
          ConfirmationCode: result.code,
        })
          .then((response) => {
            after(response);
          })
          .catch((err) => {
            after(err);
          });
      }
    }
  };

  return {
    checkRules,
  };
};
